export default __webpack_public_path__ + "474a9f49163d2806e77882ff56a9be79.svg";